import { dashboardLayoutTypeContext, dashboardTranslation } from 'app/area/dashboard/constants';
import { DashboardFavourite } from 'app/area/dashboard/dashboard-favourite';
import { useCreateMainFavouriteEffect, useDrillDown, useLoadContainerDefinitionsEffect, useSelectors } from 'app/area/dashboard/hooks';
import { FavouriteInstance } from 'app/area/favourite/favourite-context';
import { SpinLoader } from 'app/components';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import * as React from 'react';
import { LocationWithQuery } from 'app/components/enhancers/with-router';
import { useSharedState } from 'app/infrastructure/redux/hooks';

interface DashboardProps {
  dashboardType: number;
  requestedMainFavouriteId?: number;
  mainFavouriteReadOnly?: boolean;
  showDescription: boolean;
  location: LocationWithQuery;
  hideFilters?: boolean;
  hideFilterReplacements?: boolean;
  editSavedFavourite?: boolean;
}

export function Dashboard({
  dashboardType,
  requestedMainFavouriteId,
  mainFavouriteReadOnly,
  showDescription,
  location,
  hideFilters = false,
  hideFilterReplacements = true,
  editSavedFavourite = false
}: DashboardProps) {

  const translation = useTranslation(STATE.dashboard, dashboardTranslation);

  const {
    containerLayout,
    fetchingMainFavourite,
    mainFavouriteId
  } = useSelectors(dashboardType);

  const drillDown = useDrillDown(mainFavouriteId);

  useCreateMainFavouriteEffect(dashboardType, requestedMainFavouriteId, mainFavouriteReadOnly, location);

  useLoadContainerDefinitionsEffect(dashboardType, dashboardLayoutTypeContext);

  const sharedState = useSharedState();

  if (!requestedMainFavouriteId && !dashboardType && !mainFavouriteId) {
    // No dashboard to render
    return null;
  }

  return (
    !fetchingMainFavourite && !!mainFavouriteId &&
    <FavouriteInstance>
      <DashboardFavourite
        translation={translation}
        dashboardType={dashboardType}
        mainFavouriteId={mainFavouriteId}
        showDescription={showDescription}
        hideFilters={hideFilters}
        hideFilterReplacements={hideFilterReplacements}
        fetchingMainFavourite={fetchingMainFavourite}
        containerLayout={containerLayout}
        drillDown={drillDown}
        sharedState={sharedState}
        editSavedFavourite={editSavedFavourite}
      />
    </FavouriteInstance>
  ) || <SpinLoader />;
}
